import { render, staticRenderFns } from "./ProductAccordion.vue?vue&type=template&id=2c8534c4"
import script from "./ProductAccordion.vue?vue&type=script&lang=js"
export * from "./ProductAccordion.vue?vue&type=script&lang=js"
import style0 from "./ProductAccordion.vue?vue&type=style&index=0&id=2c8534c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports